import { NgModule } from '@angular/core';
import { AuthGuard } from './core/auth/guards/auth.guard';
import { RouterModule, Routes } from '@angular/router';
import { NoAuthGuard } from './core/auth/guards/noAuth.guard';
import { LayoutComponent } from './layout/layout.component';
import { ErrorPageComponent } from './modules/error-page/error-page.component';


const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },

  {
    path: 'login', 
    canActivate: [NoAuthGuard],
    data: {
      layout: 'empty',
    },
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule) 
  },

  // authenticated user
  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'main',
    },
    children: [
      {
        path: 'home',
        canActivate: [AuthGuard],
        loadChildren: () => import('./modules/home/home.module').then((m) => m.HomeModule),
      },
    ]
  },

  // Wildcard route for a 404 page
  { path: '**', component: ErrorPageComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
